import { atom, useAtomValue, useSetAtom } from 'jotai';

/** 本地搜索下拉框显示隐藏控制 */
export const searchMsgListStatus = atom<boolean>(false);

export const useSearchMsgListStatus = () => {
  return useAtomValue(searchMsgListStatus);
};

export const useSetSearchMsgListStatus = () => {
  return useSetAtom(searchMsgListStatus);
};

/** 从搜索结果打开的会话 ID 集合，这些会话不应出现在左侧会话列表中 */
export const searchOnlyConversationIdsAtom = atom<Set<string>>(new Set([]));
